// Animated underline for hero title "doing next"
// Triggers 1.75 seconds after page load with smooth hand-drawn animation

window.addEventListener('load', () => {
    const underlinePath = document.querySelector('.underline-path');
    
    if (!underlinePath) {
        return; // Gracefully exit if element doesn't exist
    }
    
    // Check for reduced motion preference
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    
    if (prefersReducedMotion) {
        // Show underline immediately without animation
        underlinePath.style.strokeDashoffset = '0';
    } else {
        // Trigger animation after 1.75 second delay
        setTimeout(() => {
            underlinePath.classList.add('animate');
        }, 1750);
    }
});

